(function setupUniversalLeadAndQuoteTracking() {
  document.documentElement.setAttribute("data-ezup-ui-events", "installed");

  if (window.__ezupUniversalLeadTrackingInstalled) {
    return;
  }

  window.__ezupUniversalLeadTrackingInstalled = true;

  var SUBMIT_LEAD_DESTINATION = "AW-621069237/z80pCOCEleUCELWHk6gC";
  var REQUEST_QUOTE_DESTINATION = "AW-621069237/I_I-CKqu1rUbELWHk6gC";
  var QUOTE_CTA_DESTINATION = "AW-621069237/nUbvCLizztccELWHk6gC";
  var LIVE_CHAT_DESTINATION = "AW-621069237/GI0cCKD_xrcbELWHk6gC";
  var EMAIL_CONTACT_DESTINATION = "AW-621069237/8lrsCPWk-tccELWHk6gC";
  var PHONE_LINK_DESTINATION = "AW-621069237/qJ4oCLmP8NccELWHk6gC";
  var BOOK_APPOINTMENT_DESTINATION = "AW-621069237/Kr5VCNGl1rUbELWHk6gC";
  var BOOK_APPOINTMENT_CTA_DESTINATION = "AW-621069237/7hWNCNft_9ccELWHk6gC";
  var STORE_DIRECTIONS_DESTINATION = "AW-621069237/V55hCNTt_9ccELWHk6gC";
  var CUSTOMIZE_PRODUCT_CTA_DESTINATION = "AW-621069237/jR7UCKab_tccELWHk6gC";
  var PENDING_FORM_KEY = "ezup_pending_lead_form";
  var LAST_LEAD_TRACKED_KEY = "ezup_last_lead_tracked_at";
  var LAST_QUOTE_TRACKED_KEY = "ezup_last_quote_tracked";
  var LAST_LIVE_CHAT_TRACKED_KEY = "ezup_last_live_chat_tracked_at";
  var PENDING_MAX_AGE = 30 * 60 * 1000;
  var QUOTE_DEDUPE_WINDOW = 10 * 1000;
  var recentQuoteClick = { signature: "", time: 0 };
  var recentStoreClicks = {};
  var hubspotSubmissions = {};
  var liveChatTracked = false;

  var GA4_EVENT_NAMES = {
    RequestQuote: "request_quote",
    QuoteCtaClick: "request_quote_cta_click",
    StoreDirectionsClick: "store_directions_click",
    BookAppointmentCtaClick: "book_appointment_cta_click",
    LiveChatOpen: "live_chat_open",
    EmailContactClick: "email_contact_click",
    PhoneLinkClick: "phone_click",
    CustomizeProductCtaClick: "customize_product_click",
    Schedule: "book_appointment"
  };

  function sendGa4Event(eventName, payload) {
    var ga4EventName = GA4_EVENT_NAMES[eventName] || eventName;

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
      window.dataLayer.push(arguments);
    };

    window.gtag("event", ga4EventName, payload || {});
  }

  function cleanText(value) {
    return String(value || "").replace(/\s+/g, " ").trim();
  }

  function publishEvent(eventName, payload) {
    window.dataLayer = window.dataLayer || [];

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    }

    sendGa4Event(eventName, payload || {});

    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === "function"
      ) {
        window.Shopify.analytics.publish(eventName, payload || {});
      }
    } catch (error) {
      console.warn("Shopify analytics event failed:", error);
    }
  }

  function trackMetaCustom(eventName, payload) {
    if (window.EzupAnalytics && typeof window.EzupAnalytics.trackCustomEvent === "function") {
      return window.EzupAnalytics.trackCustomEvent(eventName, payload || {});
    }

    publishEvent(eventName, payload || {});
    return null;
  }

  function trackMetaStandard(eventName, payload) {
    if (window.EzupAnalytics && typeof window.EzupAnalytics.trackStandardEvent === "function") {
      return window.EzupAnalytics.trackStandardEvent(eventName, payload || {});
    }

    publishEvent(eventName, payload || {});
    return null;
  }

  function trackLeadSuccess(payload) {
    if (window.EzupAnalytics && typeof window.EzupAnalytics.trackLead === "function") {
      window.EzupAnalytics.trackLead(payload || {});
      return;
    }

    var eventPayload = Object.assign({
      event_id: ["lead", Date.now(), Math.random().toString(36).slice(2, 10)].join("_")
    }, payload || {});

    publishEvent("generate_lead", eventPayload);

    try {
      window.sessionStorage.setItem(LAST_LEAD_TRACKED_KEY, String(Date.now()));
    } catch (storageError) {
      // Tracking must not block the successful submission.
    }

    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: SUBMIT_LEAD_DESTINATION,
        transport_type: "beacon"
      });
    }
  }

  function trackQuoteSuccess(payload, options) {
    var now = Date.now();
    var lastQuote = null;

    try {
      lastQuote = JSON.parse(window.sessionStorage.getItem(LAST_QUOTE_TRACKED_KEY) || "null");
    } catch (storageError) {
      lastQuote = null;
    }

    if (lastQuote && now - Number(lastQuote.time || 0) < QUOTE_DEDUPE_WINDOW) {
      return false;
    }

    var eventPayload = Object.assign({
      event_id: ["quote", now, Math.random().toString(36).slice(2, 10)].join("_"),
      content_name: document.title || "Request Quote",
      content_category: "Request Quote",
      source_page_url: window.location.href,
      result_status: "success"
    }, payload || {});

    try {
      window.sessionStorage.setItem(LAST_QUOTE_TRACKED_KEY, JSON.stringify({
        time: now,
        event_id: eventPayload.event_id
      }));
      window.sessionStorage.removeItem(PENDING_FORM_KEY);
    } catch (storageError) {
      // Tracking must not block the successful submission.
    }

    trackMetaCustom("RequestQuote", eventPayload);

    if (typeof window.gtag === "function") {
      var conversionPayload = {
        send_to: REQUEST_QUOTE_DESTINATION,
        value: 1.0,
        currency: "CAD",
        transport_type: "beacon"
      };

      if (options && options.redirectUrl) {
        conversionPayload.event_callback = function() {
          window.location.href = options.redirectUrl;
        };
      }

      window.gtag("event", "conversion", conversionPayload);
    }

    return true;
  }

  window.EzupAnalytics = window.EzupAnalytics || {};
  window.EzupAnalytics.trackQuoteSuccess = trackQuoteSuccess;
  window.EzupAnalytics.clearPendingForm = function() {
    try {
      window.sessionStorage.removeItem(PENDING_FORM_KEY);
    } catch (storageError) {
      // Tracking state must never block form UX.
    }
  };
  document.documentElement.setAttribute("data-ezup-quote-success", "installed");

  function sendAdsConversion(destination, value) {
    if (typeof window.gtag !== "function") {
      return;
    }

    window.gtag("event", "conversion", {
      send_to: destination,
      value: typeof value === "number" ? value : 0.0,
      currency: "CAD",
      transport_type: "beacon"
    });
  }

  function shouldTrackStoreClick(type, element) {
    var href = element.href || element.getAttribute("href") || "";
    var signature = [type, window.location.pathname, href].join("|");
    var now = Date.now();
    var lastTrackedAt = Number(recentStoreClicks[signature] || 0);

    if (now - lastTrackedAt < 1500) {
      return false;
    }

    recentStoreClicks[signature] = now;
    return true;
  }

  function trackStoreInteraction(type, element, text) {
    if (type === "live_chat_click") {
      var lastLiveChatTrackedAt = 0;

      try {
        lastLiveChatTrackedAt = Number(
          window.sessionStorage.getItem(LAST_LIVE_CHAT_TRACKED_KEY) || 0
        );
      } catch (storageError) {
        lastLiveChatTrackedAt = 0;
      }

      if (liveChatTracked || Date.now() - lastLiveChatTrackedAt < PENDING_MAX_AGE) {
        return;
      }
    }

    if (!shouldTrackStoreClick(type, element)) {
      return;
    }

    if (type === "live_chat_click") {
      liveChatTracked = true;

      try {
        window.sessionStorage.setItem(LAST_LIVE_CHAT_TRACKED_KEY, String(Date.now()));
      } catch (storageError) {
        // Tracking must not affect chat behaviour.
      }
    }

    var href = element.href || element.getAttribute("href") || "";
    var payload = {
      page_path: window.location.pathname,
      page_title: document.title,
      link_text: text,
      destination_url: href,
      tracking_source: "delegated_store_interaction"
    };

    var metaEventNames = {
      store_directions_click: "StoreDirectionsClick",
      book_appointment_cta_click: "BookAppointmentCtaClick",
      live_chat_click: "LiveChatOpen",
      email_contact_click: "EmailContactClick",
      phone_link_click: "PhoneLinkClick",
      customize_product_cta_click: "CustomizeProductCtaClick"
    };

    trackMetaCustom(metaEventNames[type] || type, payload);

    if (type === "store_directions_click") {
      sendAdsConversion(STORE_DIRECTIONS_DESTINATION, 0.0);
    } else if (type === "book_appointment_cta_click") {
      sendAdsConversion(BOOK_APPOINTMENT_CTA_DESTINATION, 0.0);
    } else if (type === "live_chat_click") {
      sendAdsConversion(LIVE_CHAT_DESTINATION, 0.0);
    } else if (type === "email_contact_click") {
      sendAdsConversion(EMAIL_CONTACT_DESTINATION, 0.0);
    } else if (type === "phone_link_click") {
      sendAdsConversion(PHONE_LINK_DESTINATION, 0.0);
    } else if (type === "customize_product_cta_click") {
      sendAdsConversion(CUSTOMIZE_PRODUCT_CTA_DESTINATION, 0.0);
    }
  }

  function installLiveChatVisibilityTracking() {
    if (window.__ezupLiveChatVisibilityTrackingInstalled) {
      return;
    }

    window.__ezupLiveChatVisibilityTrackingInstalled = true;
    document.documentElement.setAttribute("data-ezup-live-chat-visibility", "installed");

    var fullWidgetWasVisible = false;
    var officialListenerInstalled = false;
    var pollAttempts = 0;

    function trackLiveChatOpen(source) {
      trackStoreInteraction("live_chat_click", document.documentElement, "Live chat");

      if (liveChatTracked) {
        document.documentElement.setAttribute("data-ezup-live-chat-open-source", source);
      }
    }

    function isFullWidgetVisible() {
      var widget = document.getElementById("chat-widget");

      if (!widget) {
        return false;
      }

      var styles = window.getComputedStyle(widget);
      return styles.display !== "none" &&
        styles.visibility !== "hidden" &&
        Number(styles.opacity || 1) !== 0;
    }

    function observeWidgetState() {
      var isVisible = isFullWidgetVisible();

      if (isVisible && !fullWidgetWasVisible) {
        trackLiveChatOpen("widget_visibility");
      }

      fullWidgetWasVisible = isVisible;
    }

    function installOfficialListener() {
      pollAttempts += 1;

      if (
        !officialListenerInstalled &&
        window.LiveChatWidget &&
        typeof window.LiveChatWidget.on === "function"
      ) {
        officialListenerInstalled = true;
        window.LiveChatWidget.on("visibility_changed", function(data) {
          if (data && data.visibility === "maximized") {
            trackLiveChatOpen("official_visibility_changed");
          }
        });
        document.documentElement.setAttribute("data-ezup-live-chat-api", "installed");
      }

      if (!officialListenerInstalled && pollAttempts < 60) {
        window.setTimeout(installOfficialListener, 500);
      }
    }

    function startFallbackObserver() {
      fullWidgetWasVisible = isFullWidgetVisible();

      if (typeof window.MutationObserver !== "function") {
        return;
      }

      var observer = new MutationObserver(observeWidgetState);
      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class", "style"],
        childList: true,
        subtree: true
      });
    }

    installOfficialListener();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", startFallbackObserver, { once: true });
    } else {
      startFallbackObserver();
    }
  }

  function trackBookingSuccess(payload) {
    var eventPayload = Object.assign({
      event_id: ["booking", Date.now(), Math.random().toString(36).slice(2, 10)].join("_"),
      page_path: window.location.pathname,
      page_title: document.title,
      result_status: "hubspot_confirmed"
    }, payload || {});

    trackMetaStandard("Schedule", eventPayload);
    sendAdsConversion(BOOK_APPOINTMENT_DESTINATION, 1.0);
  }

  window.EzupStoreTracking = window.EzupStoreTracking || {};
  window.EzupStoreTracking.trackBookingSuccess = trackBookingSuccess;
  document.documentElement.setAttribute("data-ezup-store-tracking", "installed");

  function getRequestDetails(input, init) {
    var url = "";
    var method = "GET";

    if (typeof input === "string") {
      url = input;
    } else if (input && typeof input.url === "string") {
      url = input.url;
      method = input.method || method;
    } else if (typeof URL !== "undefined" && input instanceof URL) {
      url = input.href;
    }

    if (init && init.method) {
      method = init.method;
    }

    try {
      var parsedUrl = new URL(url, window.location.origin);
      var isShopifyQuoteEndpoint = parsedUrl.origin === window.location.origin &&
        parsedUrl.pathname === "/apps/forms/quote-form";
      var isLegacyQuoteEndpoint = parsedUrl.hostname === "e-z-up-email-handler.fly.dev" &&
        parsedUrl.pathname === "/submit-form";

      return {
        isQuoteSubmission: String(method).toUpperCase() === "POST" &&
          (isShopifyQuoteEndpoint || isLegacyQuoteEndpoint),
        endpoint: parsedUrl.href
      };
    } catch (urlError) {
      return { isQuoteSubmission: false, endpoint: url };
    }
  }

  function installQuoteFetchObserver() {
    if (window.__ezupQuoteFetchObserverInstalled || typeof window.fetch !== "function") {
      return;
    }

    window.__ezupQuoteFetchObserverInstalled = true;
    document.documentElement.setAttribute("data-ezup-quote-fetch", "installed");
    var nativeFetch = window.fetch;

    window.fetch = function(input, init) {
      var requestDetails = getRequestDetails(input, init);
      var fetchPromise = nativeFetch.apply(this, arguments);

      if (!requestDetails.isQuoteSubmission) {
        return fetchPromise;
      }

      return fetchPromise.then(function(response) {
        if (response && response.ok && typeof response.clone === "function") {
          return response.clone().json().then(function(result) {
            if (result && result.success === true && result.conversion_confirmed === true) {
              trackQuoteSuccess({
                tracking_source: "hubspot_confirmed_quote_endpoint",
                form_endpoint: requestDetails.endpoint
              });
            } else {
              window.EzupAnalytics.clearPendingForm();
            }
          }).catch(function() {
            // A non-JSON response is not treated as a confirmed submission.
          }).then(function() {
            return response;
          });
        }

        return response;
      });
    };
  }

  function sendQuoteCtaConversion(element, text) {
    var href = element.href || element.getAttribute("href") || "";
    var signature = [window.location.pathname, href, text].join("|");
    var now = Date.now();

    if (signature === recentQuoteClick.signature && now - recentQuoteClick.time < 1500) {
      return;
    }

    recentQuoteClick = { signature: signature, time: now };

    trackMetaCustom("QuoteCtaClick", {
      page_path: window.location.pathname,
      page_title: document.title,
      link_text: text,
      destination_url: href
    });

    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: QUOTE_CTA_DESTINATION,
        value: 0.0,
        currency: "CAD",
        transport_type: "beacon"
      });
    }
  }

  function isQuoteCta(element, text) {
    var href = String(element.href || element.getAttribute("href") || "").toLowerCase();
    var normalizedText = text.toLowerCase().replace(/[!?.]+$/g, "").trim();
    var hasQuoteTrigger = element.hasAttribute("data-quote-popup-trigger");
    var hasQuoteDestination = /\/(?:pages\/)?custom\/(?:quote|get-a-quote)(?:[/?#]|$)/.test(href) ||
      /\/pages\/custom-graphics(?:[/?#]|$)/.test(href) ||
      /#section-contact(?:$|[?&])/.test(href);
    var hasQuoteLabel = /^(?:get|request) (?:a )?quote$/.test(normalizedText) ||
      /^(?:demander|obtenir) (?:un |une )?(?:devis|soumission)$/.test(normalizedText);

    return hasQuoteTrigger || hasQuoteDestination || hasQuoteLabel;
  }

  function isNewsletterForm(form) {
    var tagsField = form.querySelector('[name="contact[tags]"]');
    var identity = [
      form.id,
      form.className,
      form.getAttribute("action"),
      tagsField && tagsField.value
    ].join(" ").toLowerCase();

    return /newsletter|subscribe|sms-sign-up|customer-login|create-customer|search-form/.test(identity);
  }

  function isLeadForm(form) {
    if (!form || isNewsletterForm(form)) {
      return false;
    }

    var hasEmail = !!form.querySelector('input[type="email"], input[name*="email" i]');
    var hasLeadDetail = !!form.querySelector(
      'textarea, input[type="tel"], input[name*="phone" i], input[name*="company" i], input[name*="message" i], input[name*="first" i], input[name*="last" i]'
    );

    return hasEmail && hasLeadDetail;
  }

  function isQuoteForm(form) {
    var identity = [
      form.id,
      form.className,
      form.getAttribute("action"),
      window.location.pathname
    ].join(" ").toLowerCase();

    return /quote-form|pdp_quote|custom\/quote|get-a-quote|custom-graphics/.test(identity);
  }

  function storePendingForm(form) {
    if (!isLeadForm(form)) {
      return;
    }

    try {
      window.sessionStorage.setItem(PENDING_FORM_KEY, JSON.stringify({
        type: isQuoteForm(form) ? "quote" : "lead",
        time: Date.now(),
        form_id: form.id || "",
        form_class: cleanText(form.className),
        source_page: window.location.pathname
      }));
    } catch (storageError) {
      // Form submission must continue if storage is unavailable.
    }
  }

  function consumeSuccessfulRedirect() {
    var isThankYouPage = /\/pages\/thank-you\/?$/.test(window.location.pathname);
    var isShopifyContactSuccess = new URLSearchParams(window.location.search)
      .get("contact_posted") === "true";

    if (!isThankYouPage && !isShopifyContactSuccess) {
      return;
    }

    var pending;

    try {
      pending = JSON.parse(window.sessionStorage.getItem(PENDING_FORM_KEY) || "null");
      window.sessionStorage.removeItem(PENDING_FORM_KEY);
    } catch (storageError) {
      return;
    }

    if (!pending || Date.now() - Number(pending.time || 0) > PENDING_MAX_AGE) {
      return;
    }

    if (pending.type === "quote") {
      trackQuoteSuccess({
        tracking_source: "confirmed_quote_redirect",
        form_id: pending.form_id,
        form_class: pending.form_class,
        source_page_path: pending.source_page
      });
      return;
    }

    var lastTrackedAt = 0;

    try {
      lastTrackedAt = Number(window.sessionStorage.getItem(LAST_LEAD_TRACKED_KEY) || 0);
    } catch (storageError) {
      lastTrackedAt = 0;
    }

    if (lastTrackedAt >= Number(pending.time || 0)) {
      return;
    }

    trackLeadSuccess({
      content_name: document.title || "Website Form",
      content_category: "Website Lead Form",
      form_id: pending.form_id,
      form_class: pending.form_class,
      source_page_path: pending.source_page,
      result_status: "success"
    });
  }

  document.addEventListener("click", function(event) {
    var target = event.target;
    var element = target && typeof target.closest === "function"
      ? target.closest("a[href], button, .chat-now, [data-ezup-live-chat]")
      : null;

    if (!element) {
      return;
    }

    var text = cleanText(element.textContent || element.getAttribute("aria-label"));
    var href = String(element.href || element.getAttribute("href") || "").toLowerCase();

    if (/google\.[^/]+\/maps|google\.com\/maps|maps\.apple\.com/.test(href)) {
      trackStoreInteraction("store_directions_click", element, text);
    } else if (/\/pages\/book-an-appointment(?:[/?#]|$)/.test(href)) {
      trackStoreInteraction("book_appointment_cta_click", element, text);
    } else if (element.classList.contains("chat-now") || element.hasAttribute("data-ezup-live-chat")) {
      trackStoreInteraction("live_chat_click", element, text);
    } else if (href.indexOf("mailto:") === 0 || element.hasAttribute("data-ezup-email-cta")) {
      trackStoreInteraction("email_contact_click", element, text);
    } else if (element.classList.contains("customize-it-btn")) {
      trackStoreInteraction("customize_product_cta_click", element, text);
    } else if (href.indexOf("tel:") === 0) {
      trackStoreInteraction("phone_link_click", element, text);
    }

    if (isQuoteCta(element, text)) {
      sendQuoteCtaConversion(element, text);
    }
  }, true);

  document.addEventListener("submit", function(event) {
    storePendingForm(event.target);
  }, true);

  window.addEventListener("message", function(event) {
    var origin = String(event.origin || "");
    var data = event.data || {};

    if (!/(?:^|\.)hubspot\.com$|(?:^|\.)hsforms\.com$/.test(origin.replace(/^https?:\/\//, ""))) {
      return;
    }

    if (data.type !== "hsFormCallback" || data.eventName !== "onFormSubmitted") {
      return;
    }

    var formId = data.id || data.formGuid || "hubspot-form";

    if (hubspotSubmissions[formId]) {
      return;
    }

    hubspotSubmissions[formId] = true;

    var hubspotIdentity = [
      formId,
      data.name,
      data.formName,
      window.location.pathname
    ].join(" ").toLowerCase();
    var isHubspotQuote = /quote|devis|soumission|custom-graphics/.test(hubspotIdentity) ||
      !!document.querySelector("[data-quote-popup-trigger], .pdp-quote-form");

    if (isHubspotQuote) {
      trackQuoteSuccess({
        tracking_source: "hubspot_confirmed_submission",
        form_id: formId
      });
    } else {
      trackLeadSuccess({
        content_name: document.title || "HubSpot Form",
        content_category: "Website Lead Form",
        form_id: formId,
        source_page_url: window.location.href,
        result_status: "success"
      });
    }
  });

  installQuoteFetchObserver();
  installLiveChatVisibilityTracking();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", consumeSuccessfulRedirect);
  } else {
    consumeSuccessfulRedirect();
  }
})();
